<template>
    <div>
        
        <v-dialog
            persistent
            v-model="display"
            width="500">
            
            <v-card>
                <v-card-title>{{title}}</v-card-title>
                <v-card-subtitle>{{ $t('TIRE_BRAND_SUBTITLE') }}</v-card-subtitle>
                <div class="text-center">
                    <v-progress-circular
                        color="primary"
                        indeterminate
                        v-if="loading.data">
                    </v-progress-circular>
                </div>
                <v-card-text>
                    <v-form
                        ref="form"
                        v-model="valid"
                        v-if="!loading.data"
                        >
                        <v-text-field
                            :label="$t('TIRE_BRAND_NAME')"
                            v-model="form.name"
                            :rules="rules.name"
                            :disabled="uneditableField('name')">
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        :disabled="!valid || loading.submitBtn"
                        :loading="loading.submitBtn"
                        @click="submit">
                        {{ $t('BTN_SAVE') }}
                    </v-btn>
                    <v-btn
                        text
                        @click="close">
                        {{ $t('BTN_CANCEL') }}
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import uneditableField from '../utils/uneditableField';
import AlertDialog from '../components/AlertDialog';
export default {
    name: "TireBrandDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            display: false,
            editMode: false,
            valid: false,
            form: {
                id: null,
                name: null
            },
            rules: {
                name: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG')
                ]
            },
            loading: {
                data: false,
                submitBtn: false
            }
        }
    },
    computed: {
        ...mapState("tireBrand", ["tireBrand"]),
        title() {
            if(!this.editMode) return this.$t('TIRE_BRAND_NEW_TITLE');
            else return this.$t('TIRE_BRAND_EDIT_TITLE');
        }
    },
    methods: {
        uneditableField,
        ...mapActions("tireBrand", ["fetchTireBrand", "storeTireBrand", "fetchTireBrands", "updateTireBrand"]),
        async open(params) {
            this.loading.data = true;
            this.display = true;
            this.editMode = params.editMode;
            if(this.editMode) {
                await this.fetchTireBrand(params.id);
                this.form = this.tireBrand;
            }
            this.loading.data = false;
        },
        close() {
            this.display = false;
            this.loading.submitBtn = false;
            this.loading.data = true;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        },
        submit() {
            this.loading.submitBtn = true;
            if(!this.editMode) {
                this.storeTireBrand(this.form)
                    .then(response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                        this.fetchTireBrands();
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    });
            } else {
                this.updateTireBrand(this.form)
                    .then(response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                        this.fetchTireBrands();
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    });
            }
        }
    }
}
</script>